import { ReactNode } from 'react';

import { TableHandleButton } from './table.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { Dropdown } from 'approot/shared/dropdown/dropdown';

type Props = {
  children: ReactNode;
  onMenuToggle: (isOpen: boolean) => void;
};

const TablePropertiesSettings = ({ children, onMenuToggle }: Props) => (
  <Dropdown
    aria-label="Edit table settings"
    borderRadius={8}
    menuWidth={170}
    dropdownContents={children}
    onToggle={isOpen => onMenuToggle(isOpen)}
    dropdownButtonContents={
      <TableHandleButton type="button" aria-label="Table Settings">
        <ActivityBuilderInlineSvg id="icon_grab" width={20} height={10} />
      </TableHandleButton>
    }
  />
);

export default TablePropertiesSettings;
